import React, { useState } from 'react';
import BoatEditModal from '../components/AdminBoatsPage/BoatEditModal';
import BoatAddModal from '../components/AdminBoatsPage/BoatAddModal';
import BoatDeleteModal from '../components/AdminBoatsPage/BoatDeleteModal';
import SearchFilter from '../components/SearchFilter/SearchFilter';
import BoatsTable from '../components/AdminBoatsPage/BoatsTable';
import BoatsBulkActions from '../components/AdminBoatsPage/BoatsBulkActions';
import useBoatActions from '../hooks/AdminBoatsPage/useBoatActions';
import AdminTableLoadingSpinner from '../components/Common/AdminTableLoadingSpinner';
import '../styles/AdminPage.css';

const AdminBoatsPage = () => {
  const [editBoat, setEditBoat] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [deleteBoat, setDeleteBoat] = useState(null);

  const {
    filteredBoats,
    categories,
    selectedBoats,
    clearSelectedBoats,
    loadBoats,
    handleFilter,
    handleSelectAll,
    handleBoatSelect,
    isLoading,
  } = useBoatActions();

  return (
    <div className="admin-page">
      <div className="admin-page__intro">
        <h1>Boats</h1>
      </div>

      <div className="admin-page__content">
        <div className="admin-page__tools">
          <SearchFilter onFilter={handleFilter} />
          <BoatsBulkActions
            selectedBoats={selectedBoats}
            clearSelectedBoats={clearSelectedBoats}
            loadBoats={loadBoats}
          />
          <div className="admin-page__tools_buttons">
            <button className="button primary" onClick={() => setIsAddModalOpen(true)}>
              Add Boat
            </button>
          </div>
        </div>

        {isLoading ? (
          <AdminTableLoadingSpinner />
        ) : (
          <>
            <BoatsTable
              boats={filteredBoats}
              onEdit={setEditBoat}
              onDelete={setDeleteBoat}
              onBoatSelect={handleBoatSelect}
              selectedBoats={selectedBoats}
              onSelectAll={handleSelectAll}
            />
            <div className="admin-page__footer">
              <p>Boats count: {filteredBoats.length}</p>
            </div>
          </>
        )}
      </div>

      <BoatEditModal
        isOpen={!!editBoat}
        onClose={() => setEditBoat(null)}
        onSuccess={() => {
          loadBoats();
          setEditBoat(null);
        }}
        boat={editBoat}
        categories={categories}
      />

      <BoatAddModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={() => {
          loadBoats();
          setIsAddModalOpen(false);
        }}
        categories={categories}
      />

      <BoatDeleteModal
        isOpen={!!deleteBoat}
        onClose={() => setDeleteBoat(null)}
        onSuccess={() => {
          loadBoats();
          setDeleteBoat(null);
        }}
        boat={deleteBoat}
      />
    </div>
  );
};

export default AdminBoatsPage;